// Moved from the app session-data wiring. History: git log --follow src/composition/hosts/session/session-data-wiring.ts
import { track, TrackingEventName } from '@heidi/analytics/events';

import { type SideBySideNoteGenEvent } from '../../contracts/side-by-side-note-gen-analytics.types';

const POSTHOG_ONLY = { amplitude: false, posthog: true } as const;

/** Routes the six side-by-side note-gen emits. */
export function trackSideBySideNoteGen(event: SideBySideNoteGenEvent): void {
  switch (event.event_name) {
    case 'note_created':
      track({
        event_name: TrackingEventName.NoteCreated,
        props: event.props,
        options: POSTHOG_ONLY,
      });
      return;
    case 'first_document_created':
      track({
        event_name: TrackingEventName.FirstDocumentCreated,
        props: event.props,
      });
      return;
    case 'note_displayed':
      track({
        event_name: TrackingEventName.NoteDisplayed,
        props: event.props,
        options: POSTHOG_ONLY,
      });
      return;
    case 'experiment_started':
      track({
        event_name: TrackingEventName.ExperimentStarted,
        props: event.props,
        options: POSTHOG_ONLY,
      });
      return;
    case 'note_selected':
      track({
        event_name: TrackingEventName.NoteSelected,
        props: event.props,
        options: POSTHOG_ONLY,
      });
      return;
    case 'note_selection_skipped':
      track({
        event_name: TrackingEventName.NoteSelectionSkipped,
        props: event.props,
        options: POSTHOG_ONLY,
      });
      return;
    default: {
      const unreachable: never = event;
      return unreachable;
    }
  }
}
